package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "hi")
val HiStrings = Strings(
    analyzer = "विश्लेषक",
    appreciationOverview = "मूल्यवृद्धि अवलोकन",
    chartLegendInterest = "ब्याज",
    chartLegendPrincipal = "मूलधन",
    chartXaxisMonths = "महीने",
    chartYaxisPayment = "भुगतान",
    code = "hi",
    costOfCredit = "क्रेडिट की लागत",
    creditDealAnalyzerDescription = "अपने क्रेडिट सौदे का व्यापक विश्लेषण प्राप्त करने के लिए अपने ऋण विवरण दर्ज करें। हमारा विश्लेषक आपको अपने ऋण की वास्तविक लागत को समझने और एक सूचित निर्णय लेने में मदद करने के लिए प्रमुख मैट्रिक्स का मूल्यांकन करता है।",
    detailsGoodRateLongTerm = "अच्छी दर लेकिन लंबी अवधि के परिणामस्वरूप उच्च कुल लागत होती है।",
    detailsHighApr = "उच्च APR। ",
    detailsHighInterestCost = "उच्च कुल ब्याज लागत।",
    detailsHighRateShortTerm = "उच्च दर लेकिन कम अवधि कुल लागत को कम रखती है।",
    detailsLowApr = "कम APR। ",
    detailsLowInterestCost = "कम कुल ब्याज लागत।",
    discountsTradeIn = "छूट / ट्रेड-इन",
    displayName = "हिन्दी",
    distribution = "वितरण",
    downPayment = "डाउन पेमेंट",
    effectiveApr = "APR",
    headerBalance = "शेष",
    headerDate = "तारीख",
    headerInterest = "ब्याज",
    headerMonth = "#",
    headerPayment = "भुगतान",
    headerPrincipal = "मूलधन",
    hideDetails = "विवरण छिपाएं",
    interest = "ब्याज",
    invalidData = "अमान्य डेटा",
    loanAmountSupportingText = "कुल ऋण राशि, किसी भी अतिरिक्त लागत सहित।",
    loanDetails = "ऋण विवरण",
    paymentSupportingText = "आपका अनुमानित मासिक भुगतान।",
    paymentComposition = "भुगतान संरचना",
    percentSymbol = "%",
    principal = "मूलधन",
    ratingBad = "बुरा सौदा",
    ratingExcellent = "उत्कृष्ट सौदा",
    ratingFair = "निष्पक्ष सौदा",
    ratingGood = "अच्छा सौदा",
    ratingPoor = "खराब सौदा",
    schedule = "अनुसूची",
    showDetails = "विवरण दिखाएं",
    summaryBad = "बहुत प्रतिकूल, यदि संभव हो तो बचें।",
    summaryExcellent = "उत्कृष्ट वित्तीय स्थितियां।",
    summaryFair = "निष्पक्ष स्थितियां, बातचीत करने पर विचार करें।",
    summaryGood = "अच्छी स्थितियां, बाजार के लिए मानक।",
    summaryPoor = "खराब स्थितियां, उच्च लागत या दर।",
    totalPaid = "कुल भुगतान",
    lockTaxRate = "कर दर लॉक करें",
    unlockTaxRate = "कर दर अनलॉक करें",
    currencySymbol = "₹",
    currency = "मुद्रा",
    totalCreditAmount = "क्रेडिट की कुल राशि",
    taxAmount = "कर/कटौती राशि",
    netAmountDisbursed = "शुद्ध वितरित राशि",
    years = "वर्ष",
    loanTermTotalMonths = "ऋण अवधि (महीने)",
    monthlyInstallment = "मासिक किस्त",
    principalInstallment = "मूलधन किस्त",
    otherFees = "अन्य शुल्क",
    insuranceCost = "बीमा प्रीमियम",
    aprc = "वार्षिक प्रतिशत दर (APRC)",
    totalAmountPayable = "कुल देय राशि",
    prepaidFeeFixed = "प्रसंस्करण शुल्क (निश्चित राशि)",
    prepaidFeePercentage = "प्रसंस्करण शुल्क (प्रतिशत)",
    months = "महीने",
    description = "यह विश्लेषक आपको यह मूल्यांकन करने में मदद करता है कि क्या ऋण प्रस्ताव आपके लिए अनुकूल है। मानक कैलकुलेटर के विपरीत, इसमें ब्याज दर इनपुट की आवश्यकता नहीं होती है। इसके बजाय, यह भुगतान और शुल्क के आधार पर APR और क्रेडिट की कुल लागत की गणना करता है, जो एक सौदा रेटिंग और विस्तृत चार्ट प्रदान करता है।",
    agree = "सहमत",
    information = "जानकारी",
    errorCalculationOverflow = "एपीआर बहुत अधिक है, गणना ओवरफ्लो।",
    errorTotalPaymentIsLessThanLoanAmount = "प्राप्त राशि ऋण राशि से कम है।",
    errorDivisionByZero = "शून्य से विभाजन",
    errorNegativeResult = "नकारात्मक परिणाम",
    errorRateTooHigh = "दर बहुत अधिक है",
    errorCalculation = "कृपया सही डेटा दर्ज करें",
    close = "बंद करें",

    hi = "नमस्ते",
    guest = "अतिथि",
    account = "खाता",
    signInWithGoogle = "Google के साथ साइन इन करें",
    signOut = "साइन आउट",
    settings = "सेटिंग्स",
    about = "के बारे में",
    privacyPolicy = "गोपनीयता नीति",
    termsOfService = "सेवा की शर्तें",
    language = "भाषा",

    theme = "थीम",
    light = "लाइट",
    dark = "डार्क",
    system = "सिस्टम",
    toggleExpand = "विस्तार/संकुचन",
)
